angular.module( 'acme.view.application.modals.checkout', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.modals.checkout.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var modalsCheckout = {
        name: 'application.modals.checkout',
        url: '/modals/checkout',
        views: {
          "main": {
            controller: 'ModalsCheckoutController',
            // Assumes the view is entirely self contained
            templateUrl: 'common/views/modals/checkout/checkout.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(modalsCheckout);
});
